import type { MessageDescriptor } from 'react-intl';
import { messages } from './messages';

export type ShortcutAction =
  | { kind: 'shading'; index: number }
  | { kind: 'zoom' }
  | { kind: 'fit' }
  | { kind: 'projection' }
  | { kind: 'measure' }
  | { kind: 'sectionSize'; grow: boolean }
  | { kind: 'escape' };

interface Shortcut {
  /** As shown in the Navigation help. */
  keys: string;
  description: MessageDescriptor;
  match: (key: string) => ShortcutAction | null;
}

/** Every key the viewer answers to, in the order the Navigation help lists them. */
export const SHORTCUTS: readonly Shortcut[] = [
  {
    keys: '1–4',
    description: messages.keyShading,
    match: (key) => (/^[1-4]$/.test(key) ? { kind: 'shading', index: Number(key) - 1 } : null),
  },
  { keys: 'Z', description: messages.keyZoom, match: (key) => (key.toLowerCase() === 'z' ? { kind: 'zoom' } : null) },
  { keys: 'F', description: messages.keyFit, match: (key) => (key.toLowerCase() === 'f' ? { kind: 'fit' } : null) },
  {
    keys: 'P',
    description: messages.keyProjection,
    match: (key) => (key.toLowerCase() === 'p' ? { kind: 'projection' } : null),
  },
  {
    keys: 'M',
    description: messages.keyMeasure,
    match: (key) => (key.toLowerCase() === 'm' ? { kind: 'measure' } : null),
  },
  {
    keys: '+ / −',
    description: messages.keySectionSize,
    match: (key) => {
      if (key === '+' || key === '=') return { kind: 'sectionSize', grow: true };
      if (key === '-' || key === '_') return { kind: 'sectionSize', grow: false };
      return null;
    },
  },
  { keys: 'Esc', description: messages.keyEscape, match: (key) => (key === 'Escape' ? { kind: 'escape' } : null) },
];

export function shortcutFor(key: string): ShortcutAction | null {
  for (const shortcut of SHORTCUTS) {
    const action = shortcut.match(key);
    if (action) return action;
  }
  return null;
}
